import { useState } from "react";
import { getAxios, route } from "../../utils/endpoints";
import { LPLNotification } from "../../types/LPLNotification";

export const useAccounts = () => {
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [textMatrix, setTextMatrix] = useState<string[][]>([]);
    const [isUploadFileDialogOpen, setIsUploadFileDialogOpen] = useState<boolean>(false);
    const [isAddUserDialogOpen, setIsAddUserDialogOpen] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);
    const [fileMessage, setFileMessage] = useState<string>("");
    const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
    const [snackbarMessage, setSnackbarMessage] = useState<string>("");
    const [snackbarSeverity, setSnackbarSeverity] = useState<string>("info");
    const [isWarningDialogOpen, setIsWarningDialogOpen] = useState<boolean>(false);

    const openSelectionFile = () => {
        const fileBtn = document.getElementById("btn-file-upload");

        if (fileBtn !== null) {
            fileBtn.click();
        }
    }

    const onOpenFileUploadDialog = () => setIsUploadFileDialogOpen(true);
    const onOpenAddUserUploadDialog = () => setIsAddUserDialogOpen(true);
    const onOpenWarningDialog = () => setIsWarningDialogOpen(true);

    const onOpenSnackbar = () => setIsSnackbarOpen(true);
    const onCloseSnackbar = () => setIsSnackbarOpen(false);


    const onCloseAddUser = () => setIsAddUserDialogOpen(false);
    const onCloseWarningDialog = () => setIsWarningDialogOpen(false);

    const onCloseUploadFileDialog = () => {
        setSelectedFile(null);
        setIsError(false);
        setFileMessage("");
        setIsUploadFileDialogOpen(false);
    }

    const onSaveFile = async () => {
        try {
            const response = await getAxios(route.apiAccount.territory, "POST", {
                territoryFile: selectedFile!
            }, undefined, "multipart/form-data");

            const data: Partial<LPLNotification> = await response.data;

            setSnackbarMessage(data.messageDetails!);
            onOpenSnackbar();

            setTimeout(() => {
                onCloseUploadFileDialog();
            }, 2000)
        } catch (error) {
            setSnackbarMessage("something went wrong");
            setSnackbarSeverity("error");
            setIsSnackbarOpen(true);
        }
    }

    const onHandleSelectionFile = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { files } = event.target;

        if (!files) {
            alert("operation cancelled");
            return;
        }

        const allowedExtensions = /(\.xls|\.xlsx|\.csv)$/i;

        if (!allowedExtensions.exec(files[0].name)) {
            setIsError(true);
            setFileMessage(`The ${files[0].type} extension is not valid`);
            return;
        }
        
        files[0]?.text().then((text) => 
        {
            const separator = text.includes(",") ? "," : ";";

            const rows = text.split("\n");
            const matrix = rows.map((row) => {
                return row.split(separator);
            });

            setTextMatrix(matrix);
        });

        console.log(textMatrix);

        setSelectedFile(files[0]);
        setIsError(false);
    }

    return {
        selectedFile,
        textMatrix,
        isError,
        isAddUserDialogOpen,
        isUploadFileDialogOpen,
        fileMessage,
        isWarningDialogOpen,
        onHandleSelectionFile,
        openSelectionFile,
        onOpenWarningDialog,
        onCloseUploadFileDialog,
        onOpenAddUserUploadDialog,
        onOpenFileUploadDialog,
        onCloseSnackbar,
        onCloseAddUser,
        onOpenSnackbar,
        snackbarSeverity,
        onCloseWarningDialog,
        snackbarMessage,
        onSaveFile,
        isSnackbarOpen
    }
}